import { Collection } from './collection'
export enum Type {
	Image = 0,
	Text,
	Link,
	Dump
}

export enum ATTRS {
	HREF = 0x1,
	TEXT = 0x2,
	SRC = 0x3,
	ALT = 0x4,
	REGEX = 0x5,
	PATH = 0x6
}

export interface IExtractor {
	attrs: Array<object>;
	types: Array<string>;
	filters: Array<string>;
	params: any;
	updateExtractor(attrName: string, add: boolean);
	// Return is given attribute is active now
	isActive(attrName: string): boolean;
}

export class LinkExtractor implements IExtractor {
	attrs = [
		{'name': 'href', 'value': ATTRS.HREF},
		{'name': 'text', 'value': ATTRS.TEXT}/* ,
		{'name': 'path', 'value': ATTRS.PATH} */];
	types = [];
	filters: Array<string>;
	params = {includeIfEmpty: false};
	constructor() {
		for (let it = 0; it < this.attrs.length - 1; it++) {
			this.types.push(this.attrs[it].name);
		}
		this.filters = new Array<string>();
		this.filters.push('Trim');
	}
	updateExtractor(attrName, add) {
		let attrValue = -1;
		for (let it = 0; it < this.attrs.length; it++) {
			if (this.attrs[it].name === attrName) {
				attrValue = this.attrs[it].value;
				break;
			}
		}
		let index = this.types.indexOf(attrName);
		if (add) {
			if (index === -1) {
				if (attrName === 'path') {
					this.types = [attrName];
				} else {
					if (this.isActive('path')) {
						this.types = [attrName];
					} else {
						this.types.push(attrName);
					}
				}
			}
		} else {
			if (index !== -1) {
				this.types.splice(index, 1);
			}
		}
		if (this.types.length === 0) {
			this.updateExtractor(attrName, true);
			throw new Error('Extractor type cannot be emty. You should choose one at least.');
		}
	}

	isActive(attrName: string): boolean {
		let active = this.types.indexOf(attrName) !== -1;
		return active;
	}
}

export class ImageExtractor implements IExtractor {
	attrs = [
		{'name': 'src', 'value': ATTRS.SRC},
		{'name': 'alt', 'value': ATTRS.ALT}];
	types = [];
	filters: Array<string>;
	params = {includeIfEmpty: false};
	constructor() {
		for (let it = 0; it < this.attrs.length; it++) {
			this.types.push(this.attrs[it].name);
		}
		this.filters = new Array<string>();
		this.filters.push('Trim');
	}
	updateExtractor(attrName, add) {
		let attrValue = -1;
		for (let it = 0; it < this.attrs.length; it++) {
			if (this.attrs[it].name === attrName) {
				attrValue = this.attrs[it].value;
				break;
			}
		}
		let index = this.types.indexOf(attrName);
		if (add) {
			if (index === -1) {
				this.types.push(attrName);
			}
		} else {
			if (index !== -1) {
				this.types.splice(index, 1);
			}
		}
		if (this.types.length === 0) {
			this.updateExtractor(attrName, true);
			throw Error('Extractor type cannot be emty. You should choose one at least.');
		}
	}

	isActive(attrName: string): boolean {
		return this.types.indexOf(attrName) !== -1;
	}
}

export class TextExtractor implements IExtractor {
	attrs = [{'name': 'regex', 'value': ATTRS.REGEX}];
	types = ['text'];
	filters: Array<string>;
	params = {regexp: '', includeIfEmpty: false};
	constructor() {
		this.filters = new Array<string>();
		this.filters.push('Trim');
	}
	updateExtractor(attrName, add) {
		let index = this.types.indexOf(attrName);
		if (add) {
			if (index === -1) {
				let i = this.types.indexOf('text');
				if (i !== -1) {
					this.types.splice(i, 1);
				}
				this.types.push(attrName);
			}
		} else {
			if (index !== -1) {
				let i = this.types.indexOf('regex');
				if (i !== -1) {
					this.types.splice(i, 1);
				}
				this.types.push('text');
			}
		}
	}
	/* isRegex(): boolean {
		return (this.mask & ATTRS.REGEX) > 0;
	} */

	isActive(attrName: string): boolean {
		return this.types.indexOf(attrName) !== -1;
	}
}

export class Extractor {
	type = 'text';
	params: any = {includeIfEmpty: false};
	fieldMapValue = 1;
	filter: Array<string>;
}

export class Filter {
	constructor(public name: string, public param: string) {}
}

export class Field {
	/* name = '';
	selector = '';
	details: Collection = null;
	count = 0; */
	attrs = Array<string>();
	type = Type.Text;
	filters = Array<Filter>(new Filter('trim', ''))

	constructor(public name: string, public selector: string, public details: Collection, public count?: number) {
		 this.type = Type.Dump;
	}

	public toggleType() {
		this.type = (this.type < 2) ? this.type + 1 : 0;
		this.updateExtractorType();
	}

	public filterIndex(filterName: string): number {
		filterName = filterName.toLowerCase()
		for (let idx = 0; idx < this.filters.length; idx ++) {
			if (this.filters[idx].name === filterName) {
				return idx;
			}
		}
		return -1;
	}

	public updateAttrs(attrName: string, addAttr: boolean) {
		if (!addAttr && this.attrs.length === 1) {
			throw new Error('Field should has at least one attribute to extract. Choose the one.');
		}
		attrName = attrName.toLowerCase();
		let attrIndex = this.attrs.indexOf(attrName);
		if (addAttr) {
			if (attrIndex === -1) {
				if (attrName === 'path' || attrName !== 'path' && this.isActive('path')) {
					this.attrs = [];
				}
				this.attrs.push(attrName);
			}
		} else {
			if (attrIndex !== -1) {
				this.attrs.splice(attrIndex, 1);
			}
		}
	}

	public isActive(attrName: string): boolean {
		return this.attrs.indexOf(attrName) !== -1;
	}

	private updateExtractorType() {
		/* switch (this.type) {
			case Type.Image: {
				this.extractor = new ImageExtractor()
			} break;
			case Type.Link: {
				this.extractor = new LinkExtractor();
			} break;
			case Type.Text: {
				this.extractor = new TextExtractor();
			}
		} */
	}
}
